class ToggleViewManager {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.elements = []
    }
    run() {
        document.querySelectorAll('[data-toggle-view]').forEach((el) => {
            const mToggleView = new ToggleView(el, this)
            mToggleView.run()
            this.elements.push(mToggleView)
        })
    }
    closeAll() {
        this.elements.forEach(mToggleView => mToggleView.closeAction())
    }
}

class ToggleView {
    constructor(el, parent) {
        this.el = el
        this.parent = parent
        this.classOpen = this.el.dataset.toggleView;
    }
    run() {
        this.el.querySelectorAll('[data-toggle-view-action]').forEach((elAction) => this.initAction(elAction))
        this.el.addEventListener('show-extra', () => {
            this.parent.closeAll()
            this.openAction()
        })
    }
    initAction(elAction) {
        elAction.addEventListener('click', (evt) => {
            if ("allow-default" !== elAction.dataset.toggleViewAction) {
                evt.preventDefault()
            }
            this.parent.closeAll()
            this.openAction()
        })
    }
    openAction() {
        this.el.classList.add(this.classOpen)
    }
    closeAction() {
        this.el.classList.remove(this.classOpen)
    }
}

export default ToggleViewManager